import { View } from "react-native";
import React from "react";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import Container from "./Container";
import TenantLogo from "./TenantLogo";
import FanRallyLogo from "./FanRallyLogo";
import AgreementText from "./AgreementText";

const LOGO_SIZE = 35;
const Footer = () => {
  const { data: branding } = useFetchTenantBrandingQuery();

  return (
    <View style={{ backgroundColor: branding?.primaryColor }} className=" h-24">
      <Container>
        <View className="flex-row justify-center p-4 gap-4">
          <TenantLogo width={LOGO_SIZE} height={LOGO_SIZE} isDarkBackground />
          <FanRallyLogo width={LOGO_SIZE} height={LOGO_SIZE} />
        </View>
        <View>
          <AgreementText
            variant="FOOTER"
            textStyle={{
              color: "white",
            }}
          />
        </View>
      </Container>
    </View>
  );
};

export default Footer;
